<script lang="ts" setup>
import type { JIIcon } from "@/icomponents";
import { computed } from "vue";

const props = defineProps<JIIcon>();

const iconClasses = computed(() => {
  const classes = [];

  if (props.color) {
    classes.push(props.color);
  }

  if (props.class) {
    classes.push(props.class);
  }

  return classes.join(" ");
});
</script>

<template>
  <iconify-icon
    v-bind="$attrs"
    :class="iconClasses"
    :flip="flip"
    :height="height || 22"
    :icon="icon"
    :inline="inline"
    :mode="mode"
    :rotate="rotate"
    :style="style"
    :width="width"
  ></iconify-icon>
</template>

<style scoped>
.danger-icon {
  color: red;
}

.jt-dark.danger-icon {
  color: yellow;
}

.blue-icon {
  color: blue;
}

.success-icon {
  color: darkcyan;
}
</style>
